import { ActionItem } from "./action-item";

export interface IActionItem {
    id: ActionItem;
    description: string;
    location?: string;
    useWindow: boolean;
    separateTab: boolean;
}

export const actionItemMap = (centerId: number): IActionItem[] => {
    return [
        {
            id: ActionItem.MatchOffers,
            description: 'Match Offers',
            useWindow: true,
            separateTab: false,
        },
        {
            id: ActionItem.RequestForDonorReview,
            description: 'Requests for Donor Review',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.XMResults,
            description: 'XM Results',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.DonorClearance,
            description: 'Donor Clearance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.EmergencySwapNotification,
            description: 'Emergency Swap Notifications',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.LogisticsKickoffCalls,
            description: 'Logistics/Kickoff Calls',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.Preselects,
            description: 'Pre-Selects Outstanding',
            useWindow: false,
            separateTab: false,
            location: `/center/${centerId}/recipients/donor-pre-select`
        },
        {
            id: ActionItem.StagnantMicrositeUpdates,
            description: 'Stagnant Microsite Updates',
            useWindow: false,
            separateTab: false,
            location: `/center/${centerId}/microsite/stagnant-sites`
        },
        {
            id: ActionItem.TransplantPickup,
            description: 'Transplant Pickups',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.TransplantDelivery,
            description: 'Transplant Deliveries',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.Invoice,
            description: 'Invoices',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.Rccap,
            description: 'RCCAPs',
            useWindow: false,
            separateTab: false,
            location: `/center/${centerId}/reports/my-center/rccap`
        },
        {
            id: ActionItem.DashContactDue,
            description: 'DASH Contacts Due',
            useWindow: false,
            separateTab: false,
            location: `/center/${centerId}/donors/donor-intake/to-do`
        },
        {
            id: ActionItem.WaitListAnatomyCompliance,
            description: 'Wait List Anatomy Compliance',
            useWindow: false,
            separateTab: true,
            location: `/center/${centerId}/profile/edit/anatomy-prefs`
        },
        {
            id: ActionItem.ActiveRecipientDataCompliance,
            description: 'Active Recipient Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PostTransplantRecipientDataCompliance,
            description: 'Post Txp Recipient Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.ActiveDonorDataCompliance,
            description: 'Active Donor Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.ActiveRdnDonorDataCompliance,
            description: 'Active RDN Donor Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PostTransplantDonorDataCompliance,
            description: 'Post Txp Donor Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PostTransplantRdnDonorDataCompliance,
            description: 'Post Txp RDN Donor Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.ConfirmReimbursementDonations,
            description: 'Confirm Donor Reimbursement Eligibility',
            useWindow: false,
            separateTab: true,
            location: 'center/' + centerId + '/donors/watr',
        },
        {
            id: ActionItem.ConfirmDashDonations,
            description: 'Confirm DASH Donations',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.MissingVoucherHolders,
            description: 'Missing Voucher Holders',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.CustomLogistics,
            description: '',
            useWindow: false,
            separateTab: false,
            location: `/center/${centerId}/action-center/pending-swaps`
        },
        {
            id: ActionItem.DonationDateRangeConflict,
            description: 'Donation Date Range Conflict',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.DonorEval,
            description: 'Donor Evaluation',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PendingRecipientReferrals,
            description: 'Referrals Missing a Disposition',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PendingPatientIntakeReferrals,
            description: 'Pending Patient Intake Referrals',
            useWindow: false,
            separateTab: true,
            location: `/center/${centerId}/recipients/patient-intake/to-do`
        },
        {
            id: ActionItem.LostChainStarters,
            description: 'Inactive Donor Verification',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.FinalXmReults,
            description: 'Final XM Results',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.WageAndTravelRequests,
            description: 'Wage and Expense Requests',
            useWindow: false,
            separateTab: true,
            location: 'center/' + centerId + '/donors/watr',
        },
        {
            id: ActionItem.VoucherDonors,
            description: 'Voucher Self Registration',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.HasAbWaitListPatients,
            description: 'Centers w/ AB Waitlist Patients',
            useWindow: false,
            separateTab: false,
            location: `center/${centerId}/profile/edit/services-data`,
        },
        {
            id: ActionItem.RemoteWorkupsNotBilled,
            description: 'Remote Workups Not Billed/Processed',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.FlaggedForVoucherDonation,
            description: 'Flagged for Voucher Donation',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.OutstandingInternalDirectSwaps,
            description: 'Confirm ID Donation/Transplant Occurred',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.MissingVoucherConsents,
            description: 'Missing Voucher Holder Consents',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.MicrositeDataCompliance,
            description: 'Microsite Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.AtRiskMortalityRecipients,
            description: 'At Risk Mortality Recipients',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.OutstandingDonorReimbursements,
            description: 'Outstanding Donor Reimbursements',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.DonorsWithRemoteRecipient,
            description: 'Donors Registered With Intended Recipients',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.MicrositePatientsPendingApproval,
            description: 'Microsites Pending Approval',
            useWindow: true,
            separateTab: false
        },
        // {
        //     id: ActionItem.ImmunoFreeCandidates,
        //     description: 'Invite ImmunoFree Candidates',
        //     useWindow: true,
        //     separateTab: false
        // }
        {
            id: ActionItem.LdPrioritization,
            description: 'Donors Missing LD Priorization',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.CenterContactPositions,
            description: 'Center Contact Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PassMissingRecipientProfile,
            description: 'Complete PASS Profile',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.StrongBoxDataCompliance,
            description: 'StrongBox Data Compliance',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.PackagingRemittance,
            description: '',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.ConfirmSerologyBloodDraw,
            description: 'Serology: Confirm Draw Date',
            useWindow: true,
            separateTab: false
        },
        {
            id: ActionItem.ConfirmBloodDrawCompletion,
            description: 'Serology: Confirm Draw Complete',
            useWindow: true,
            separateTab: false
        }
    ]
};